<template>
<PrimevueCard  class="w-full mt-2" >
    <template #title>
      <div class="font-medium text-xl">
            Cortizo proformy
      </div>
    </template>
    <template #content>

      <div class="field grid align-items-center">
        <label for="number-of-proform" class="mb-0 col-fixed" style="width:130px">Číslo proformy</label>
        <div class="col-3">
            <InputText class="w-full" 
            :class="`${v$.proform.code.$error ? 'bg-red-200' : ''}`"
            :invalid="v$.proform.code.$error"
            v-model="this.proform.code"
            type="text"
            name="number-of-proform"
            id="number-of-proform"
          >
          </InputText>
          <div
              v-for="(error, index) of v$.proform.code.$errors"
              :key="index"
              class="text-sm font-italic text-red-400"
          >
            {{ error.$message }}
          </div> 

        </div>
        <div class="col-fixed add-cortizo" style="width:150px">
          <PrimevueButton @click="addProform()" label="Pridať" 
            severity="success"  icon="pi pi-plus-circle" text raised class="w-full uppercase"/>
        </div>

      </div>

      <Fieldset legend="Zoznam čísiel proforiem" >
          <div class=" pt-1 pb-1 flex flex-wrap gap-1">
              <div v-for="proform of this.proforms" :key="proform.code" class="shadow-2 p-1 flex surface-card w-15rem">
                  <div class="w-10 align-items-center">
                     
                      <div class="text-600 text-base font-medium border-bottom-1">{{proform.code}}</div>
                      <div v-for="(box,index) of proform.boxes" :key="box.id" 
                           class="text-500 text-base font-medium">
                             {{box.code}}{{ (proform.boxes.length > index+1) ? "," : ""}}
                      </div>
                  </div>
                  <div class="w-2 justify-content-center align-items-center flex">
                      <PrimevueButton class="file-danger" icon="pi pi-times" @click="deleteProform(proform.id)" severity="danger" />
                  </div> 
              </div>
                  
              
          </div>
      </Fieldset>
    </template>

</PrimevueCard>


</template>

<script lang="ts">
import Security from './security'
import {store} from './store'
import PrimevueCard from 'primevue/card';
import notie from "notie/dist/notie";
//import {emiter} from '../main';
import Fieldset from 'primevue/fieldset';
import { useVuelidate } from '@vuelidate/core'
import { required, helpers, minLength  } from '@vuelidate/validators'
import PrimevueButton from 'primevue/button';

export default {
    name: 'CortizoProform',
    components: {
      PrimevueButton,
      PrimevueCard,
      Fieldset,
    },
    props: [

       "orderId",
       
       ],
    data() {
        return {
            store,
            proforms : [],
            dialogClosedByAccept: false,
            proform: {
              id: 0,
              code: "",
            }
        }
    },
 
    setup () {
      return {
        v$: useVuelidate()
      }
    },

    validations () {
      return {
        proform: {
          code: { required: helpers.withMessage('Číslo nesmie byť prázdne', required),
                  minLength: helpers.withMessage('Číslo musí obsahovať min. 3 znaky', minLength(3)),
                },
              }
            }
    },          
   
    beforeMount() {

      if(Security.requireToken()){
        
        store.selectModul = this.$route.path.split("/")[1]
        
        this.loadData();
        //emiter.on('reloadAttByType',this.loadData)
      }
    },
    
    methods: {
      loadData(){

        let condition = "?query=deleted:0,order_id:"+ this.$props.orderId
        //if(store.user.department.id == 1){
        //  condition = "?internal=true"
        //}
      
        fetch(store.Api_url + "/v1/cortizo-proform" +condition , Security.requestOptions("GET"))
              .then((response) => response.json())
              .then((responseData) => {
                if (responseData.error) {
                  //console.log("error:", responseData.message);
                  notie.alert({
                    type: 'error',
                    text: 'Nepodarilo sa načítať zoznam proforiem '+ responseData.data.message,
                    position: "bottom"
                  })          
                } else {
                  
                  if(responseData.data != null){
                    this.proforms = responseData.data;

                  } else{

                    this.proforms = []

                  }
    
  
                }
        });
      },

      async addProform(){
      
        const result = await this.v$.$validate()
        
        if (!result) {
          // notify user form is invalid
          return
        }

        let formData = {
          id: 0,
          code: this.proform.code,
          order: {id: parseInt(this.$props.orderId)}
        }

        const method = "POST"
        const url = "/v1/cortizo-proform"

        fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Proforma bola uložená"
              })

              this.proform = {id:0 , code:""}

              this.v$.$reset()
                             
              this.loadData()
            
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri uložení proformy" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení proformy" + error
            })
          })

      },

      deleteProform(id:number){
      
        Security.requireToken();
        this.dialogClosedByAccept = false;
        this.$confirm.require({
          message: 'Naozaj chcete ODSTRÁNIŤ proformu? Zrušia sa k nej priradenia všetkých krabíc !',
          header: 'Odstránenie proformy',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            //this.user.admin = event.target.checked;
            this.dialogClosedByAccept = true;

            fetch(store.Api_url + "/v1/cortizo-proform/"+String(id)+"?query=deleted:0,order_id:"+this.$props.orderId , Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo sa odstrániť proformu"
                })
              } else {

                this.proforms = responseData.data;
                
                notie.alert({
                  type: 'success',
                  text: "Proforma bola odstránená",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri odstránení proformy: "+error
                })             
            })
          },

          onHide: () => {

              this.dialogClosedByAccept = false;
          }

        });

    },

    },


    beforeUnmount(){
      //emiter.off('reloadAttByType',this.loadData);
    },  
}    
</script>